import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import TransactionService from "../TransactionService";
import Box from "../../component/Box/Box";
import AssetSelector from "../../component/Asset/AssetSelector";
import CheckpointSelector from "../../checkpoint/CheckpointSelector";
import {ControlLabel, FormControl, FormGroup} from "react-bootstrap";
import Notify from "../../services/Notify";
import FormButtons from "../../component/Form/FormButtons";
import Loading from "../../component/Loading/Loading";
import ReadpointSelector from "../../readpoint/component/ReadpointSelector";

class TransactionForm extends React.Component {

  service = new TransactionService();
  refs = {};

  constructor(props) {
    super(props);
    this.state = {entity: {}, defaultAssets: []};
    this.state.defaultValue = (this.props.history.location.aboutProps && this.props.history.location.aboutProps.listAssetsChecked) || [];
  }

  submitForm() {

    const entity = {
      checkpointId: this.checkpointId,
      readpoint: this.readpoint,
      assets: this.assets.map(asset => ({id: asset.id})),
      reason: ReactDOM.findDOMNode(this.refs.userReason).value.trim()
    };
    this.setState({loading: true, message: 'Salvando...'});
    this.service.createManual(entity, entity.checkpointId).then(
        (data) => {
          Notify.success('Transação criada, ela sera processada em breve');
          this.props.history.push('/transactions/' + data.id);
        },
        (error) => {
          Notify.error('Falha ao criar transação:', error);
          this.setState({loading: false, entity, message: null});
        });
  }

  render() {
    const listAssetsChecked = this.state.defaultValue;
    const {loading, entity, message} = this.state;
    if (loading) {
      return <Loading message={message}/>
    }

    return (<Box info
                 title="Criar uma transação manualmente, que irá alterar o local, etapa e/ou situação do ativo/produto.">


          <form onSubmit={event => {
            event.preventDefault();
            this.submitForm()
          }}>
            <AssetSelector
                multiple={true}
                required={true}
                defaultValue={listAssetsChecked}
                setValue={assets => {
                  this.assets = assets;
                }}
            />
            <CheckpointSelector required={true} setValue={
              checkpointId => this.checkpointId = checkpointId}/>

              <ReadpointSelector  onChange={
                  readpoint => this.readpoint = readpoint}/>

            <FormGroup>
              <ControlLabel>Motivo</ControlLabel>
              <FormControl componentClass="textarea" className="form-control"
                           required={true}
                           placeholder="Motivo para esta ação"
                           ref="userReason"/>
            </FormGroup>


            <FormButtons history={this.props.history}/>
          </form>
        </Box>
    );
  }
}

TransactionForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default TransactionForm;



// WEBPACK FOOTER //
// ./src/transaction/component/TransactionForm.js